import React, { useState } from "react";
import CustomTabs from "components/tabs/customTab";
import { Gift, ShoppingCart, TrendingUp, Trophy, Sparkles } from "lucide-react";
import AwardCreditSummaryCard from "./AwardCreditSummaryCard";
import RewardCategoryCard from "./RewardCategoryCard";
import RecentActivitySummary from "./RecentActivitySummary";
import OverviewSummaryCard from "./OverviewSummaryCard";
import MilestoneSummary from "./MilestoneSummary";
import LeaderboardSummary from "./LeaderboardSummary";
import HyvidPointsPurchase from "./HyvidPointsPurchase";
import Nominations from "./Nominations";


const HyvidRewardsTab = () => {
  const [activeTab, setActiveTab] = useState("credits");

  const tabOptions = [
    {
      label: "Award Credits", 
      value: "credits",
      icon: <Gift/>,
    },
    {
      label: "My Nominations",
      value: "nominations",
      icon: <Sparkles/>,
    },
    {
      label: "Overview",
      value: "overview",
      icon: <TrendingUp/>,
    },
    {
      label: "Leaderboard", 
      value: "leaderboard",
      icon: <Trophy/>,
    },
    {
      label:"Purchase", 
      value: "purchase",
      icon: <ShoppingCart/>,
    },
  ];

  return (
    <div className="flex flex-col gap-4">
      <CustomTabs
        tabs={tabOptions}
        height="h-10"
        activeTab={activeTab}
        onChange={setActiveTab}
      />
      <div className="mt-3 space-y-4">
        {activeTab === "credits" &&
          <div className="space-y-6">
            <AwardCreditSummaryCard/>
            <RewardCategoryCard/>
            <MilestoneSummary/>
          </div>
        }
        {activeTab === "nominations" &&
          <div className="space-y-6">
            <Nominations/>
          </div>
        }
        {activeTab === "overview" &&
          <div className="space-y-6 ">
            <OverviewSummaryCard/>
            <RecentActivitySummary/>
          </div>
        }
        {activeTab === "leaderboard" &&
          <div className="space-y-6 ">
            <LeaderboardSummary/>
          </div>
        }
        {activeTab === "purchase" &&
          <div className="space-y-6">
            <HyvidPointsPurchase/>
          </div>
        }
      </div>
    </div>
  );
};

export default HyvidRewardsTab;
